import * as React from "react";
import { FocusFormBuilder } from "./FocusFormBuilder";
import { FocusFormDataContext, setDisable } from "./utils";
import "./focusForm.scss";
export const FocusForm = ({ schema, uiSchema, formData, readOnly, errors, ommitDisabledCheck, onChange, }) => {
    let contextData = React.useContext(FocusFormDataContext);
    const hasTab = (uiSchema) => {
        const firstComp = uiSchema["ui:order"][0];
        const hasTab = uiSchema[firstComp]["ui:field"] === "tabfield";
        return hasTab;
    };
    if (schema.minProperties === 0) {
        return null;
    }
    else {
        const tabPresent = hasTab(uiSchema);
        let parsedUiSchema = uiSchema;
        if (!ommitDisabledCheck) {
            parsedUiSchema = setDisable(tabPresent, contextData, uiSchema, schema, formData);
        }
        return (React.createElement(FocusFormBuilder, { hasTab: tabPresent, schema: schema, uiSchema: parsedUiSchema, formData: formData, readOnly: readOnly, errors: errors, onChange: onChange }));
    }
};
//# sourceMappingURL=FocusForm.js.map